var React = require('react');

function CirclePlusInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20.3168","cy":"20.5","r":"19.6","fill":"white","key":0}),React.createElement("path",{"d":"M14.3335 20.5H24.6668","stroke":"#0A9E50","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M19.5 25.6666V15.3333","stroke":"#0A9E50","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

CirclePlusInline.defaultProps = {"width":"40","height":"41","viewBox":"0 0 40 41","fill":"none"};

module.exports = CirclePlusInline;

CirclePlusInline.default = CirclePlusInline;
